import { OnInit, } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
var ViewTaskDetailImagesComponent = /** @class */ (function () {
    function ViewTaskDetailImagesComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
    }
    ViewTaskDetailImagesComponent.prototype.ngOnInit = function () {
        this.selectedPhoto = this.photos[this.selectedIndex];
    };
    ViewTaskDetailImagesComponent.prototype.close = function () {
        this.bsModalRef.hide();
    };
    ViewTaskDetailImagesComponent.prototype.handleKeyboardEvent = function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            this.showNextImage();
        }
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            this.showPreviousImage();
        }
    };
    ViewTaskDetailImagesComponent.prototype.showNextImage = function () {
        if (this.selectedIndex < this.photos.length - 1) {
            this.selectedIndex++;
            this.selectedPhoto = this.photos[this.selectedIndex];
        }
    };
    ViewTaskDetailImagesComponent.prototype.showPreviousImage = function () {
        if (this.selectedIndex > 0) {
            this.selectedIndex--;
            this.selectedPhoto = this.photos[this.selectedIndex];
        }
    };
    return ViewTaskDetailImagesComponent;
}());
export { ViewTaskDetailImagesComponent };
